export default {
  init() {

    
    /*var that = this;
    $('.result-video').bind('click', function(e){
      e.preventDefault();

      var id = $(this).attr('data-video');
      that.showModal(id);
    });*/

  },

  showModal(videoId) {
    $('#ifVideo').attr('src', 'https://www.youtube.com/embed/' + videoId)
    $('#modalVideo').modal();

    $('#modalVideo').on('hidden.bs.modal', function () {
      $('#ifVideo').attr('src', '');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/mediatheque.js